document.addEventListener('DOMContentLoaded', function () {
	const viewStaffLinks = document.querySelectorAll('.view-staff');

	viewStaffLinks.forEach(link => {
		// Get the target collapse element
		const targetId = link.getAttribute('href').replace('#', '');
		const targetElement = document.getElementById(targetId);

		// Listen for collapse events
		targetElement.addEventListener('shown.bs.collapse', function () {
			link.innerHTML = `
                Hide Staff
                <span class="icon">
                    <i class="far fa-minus"></i>
                </span>
            `;
		});

		targetElement.addEventListener('hidden.bs.collapse', function () {
			link.innerHTML = `
                Show Staff
                <span class="icon">
                    <i class="far fa-plus"></i>
                </span>
            `;
		});
	});
});
